import React from "react";

import { useTranslation, Trans } from "react-i18next";

import star from '../../img/Home/star.png';
import stars from '../../img/Home/stars.png';
import colls from '../../img/Home/colls.png';

import Fade from "react-reveal/Fade";

function TrustPilot () {

    const { t } = useTranslation();
      
    return(
        <div className="relative pt-[90px] xl:pt-[160px]">
            <div className="max-w-[1220px] xl:mx-auto relative xl:h-[337px] rounded-[20px] bg-[#CEDFF2] flex flex-col justify-center">
                <div className="flex flex-col-reverse xl:flex-row justify-between items-center xl:px-[100px] py-[50px] xl:py-0">
                    <div className="flex flex-col items-center xl:items-start mt-[30px] xl:mt-0">
                        <div className="flex gap-[11px] items-center">
                            <img src={star} alt="" />
                            <p className="text-[26px] font-[700] text-black open-sans leading-[1.2]">Trust Pilot</p>
                        </div>
                        <p className="open-sans font-[300] text-[14px] leading-[1.2] text-black mt-[15px]">{t('home.27')}</p>
                        <img src={stars} alt="" className="mt-[5px]"/>
                        <p className="mt-[12px] open-sans text-[19px] font-[300] fontfont"><Trans>{t('home.28')}</Trans></p>
                    </div>
                    <Fade delay={500}><img src={colls} alt="" className="px-[20px] xl:px-0"/></Fade>
                </div>
            </div>
        </div>
    );
}

export default TrustPilot;